import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Cases from './pages/Cases';
import CaseDetail from './pages/CaseDetail';
import Evidence from './pages/Evidence';
import EvidenceUpload from './pages/EvidenceUpload';
import PublicSubmission from './pages/PublicSubmission';
import CustodyChain from './pages/CustodyChain';
import AuditLog from './pages/AuditLog';
import PIIDemo from './pages/PIIDemo';
import Filing from './pages/Filing';
import CourtFiling from './pages/CourtFiling';
import PendingFilings from './pages/PendingFilings';
import Discovery from './pages/Discovery';
import Disposition from './pages/Disposition';
import Courtroom from './pages/Courtroom';
import Compliance from './pages/Compliance';
import DemoHub from './pages/DemoHub';
import Diagrams from './pages/Diagrams';
import AIAgents from './pages/AIAgents';
import EvidenceIntake from './pages/EvidenceIntake';
import MyCases from './pages/MyCases';
import { NotificationList } from './components/notifications';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="cases" element={<Cases />} />
        <Route path="cases/:caseNumber" element={<CaseDetail />} />
        <Route path="evidence" element={<Evidence />} />
        <Route path="evidence/intake" element={<EvidenceIntake />} />
        <Route path="submissions" element={<EvidenceIntake />} />
        <Route path="evidence/upload" element={<EvidenceUpload />} />
        <Route path="evidence/:evidenceId" element={<Evidence />} />
        <Route path="submit" element={<PublicSubmission />} />
        <Route path="my-cases" element={<MyCases />} />
        <Route path="custody/:evidenceId" element={<CustodyChain />} />
        <Route path="audit" element={<AuditLog />} />
        <Route path="filing" element={<Filing />} />
        <Route path="court-filing" element={<CourtFiling />} />
        <Route path="pending-filings" element={<PendingFilings />} />
        <Route path="discovery" element={<Discovery />} />
        <Route path="disposition" element={<Disposition />} />
        <Route path="courtroom" element={<Courtroom />} />
        <Route path="compliance" element={<Compliance />} />
        <Route path="demo-hub" element={<DemoHub />} />
        <Route path="diagrams" element={<Diagrams />} />
        <Route path="ai-agents" element={<AIAgents />} />
        <Route path="pii-demo" element={<PIIDemo />} />
        <Route path="notifications" element={<NotificationList />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
